import { ApiClientProvider, type Me, OrgProvider } from "@/lib/api";
import { requireAuth } from "@/lib/auth";
import { ToastProvider } from "@/lib/toast";
import { X } from "lucide-react";
import { Dialog } from "radix-ui";
import { useRef, useState } from "react";
import { Outlet, useLoaderData } from "react-router";
import { CreateOrgGate } from "./CreateOrgGate";
import { ImpersonationBanner } from "./ImpersonationBanner";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";

export const appShellLoader = requireAuth;

export function AppShell() {
  const me = useLoaderData() as Me;
  const [mobileOpen, setMobileOpen] = useState(false);
  const opener = useRef<HTMLElement | null>(null);
  return (
    <ApiClientProvider>
      <ToastProvider>
        <OrgProvider>
          <div className="console-shell">
            <a className="skip-link" href="#workspace">
              Skip to content
            </a>
            {me.impersonation && <ImpersonationBanner impersonation={me.impersonation} />}
            <div className="console-frame">
              <aside className="desktop-sidebar">
                <Sidebar />
              </aside>
              <Dialog.Root open={mobileOpen} onOpenChange={setMobileOpen}>
                <Dialog.Portal>
                  <Dialog.Overlay className="nav-overlay" />
                  <Dialog.Content
                    className="mobile-sidebar"
                    aria-describedby={undefined}
                    onCloseAutoFocus={(event) => {
                      event.preventDefault();
                      opener.current?.focus();
                    }}
                  >
                    <Dialog.Title className="sr-only">Workspace navigation</Dialog.Title>
                    <Dialog.Close className="nav-close" aria-label="Close navigation">
                      <X size={19} />
                    </Dialog.Close>
                    <Sidebar onNavigate={() => setMobileOpen(false)} />
                  </Dialog.Content>
                </Dialog.Portal>
              </Dialog.Root>
              <div className="console-body">
                <TopBar
                  me={me}
                  onOpenSidebar={() => {
                    opener.current = document.activeElement as HTMLElement;
                    setMobileOpen(true);
                  }}
                />
                <main id="workspace" tabIndex={-1} className="workspace-content">
                  <CreateOrgGate>
                    <Outlet context={me} />
                  </CreateOrgGate>
                </main>
              </div>
            </div>
          </div>
        </OrgProvider>
      </ToastProvider>
    </ApiClientProvider>
  );
}
